import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "rc-time-picker/assets/index.css";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import CitySuggestionsCMP from "./SubComponents/SuggetionsDrop";
import SwapCityCMP from "./SubComponents/SwapCity";
import DatePickerInput from "./SubComponents/Date";
import TimePickerInput from "./SubComponents/Time";
import { useNavigate } from "react-router-dom";
import OneWayCitySuggetion from "./SubComponents/OneWayDropSuggetion";
import moment from "moment";
import toast from "react-hot-toast";

const OneWaysSearchTab = ({ tripType }) => {
    const [check, setCheck] = useState(false);


    // use navigation for redirect the another page
    const Navigation = useNavigate();

    // handle data and Times
    const [selectedDate, setSelectedDate] = useState(null);
    const [formData, setFormData] = useState({
        from_city: "",
        from_city_id: "",
        from_state_id: "",
        from_state_name: "",
        trip_type: tripType,
        to_city: "",
        to_city_id: "",
        to_state_id: "",
        to_state_name: "",
        pickup_date: "",
        pickup_time: '',
        drop_date: "",
        package: '',
        package_id: '',
        vehicle_name: "",
        vehicle_id: ""
    });

    const HandleChangesData = (DataObject) => {
        for (let property in DataObject) {
            formData[property] = DataObject[property]
        }
        setFormData({
            ...formData
        })
    }

    useEffect(() => {
        let GetLocalDb = JSON.parse(localStorage.getItem('cab_listing')) || {};
        if (GetLocalDb.trip_type === tripType) {
            HandleChangesData(GetLocalDb)
        }
    }, [])

    // handle submit handle tab
    const CabSearchSubmit = (e) => {
        e.preventDefault();
        //
        if (formData.from_city === '' || formData.from_city.length < 1) {
            toast.error("Please select the pickup location")
            return;
        }
        if (formData.to_city === '' || formData.to_city < 1) {
            toast.error("Please select the drop location")
            return;
        }
        if (formData.pickup_date.length < 1 || formData.pickup_date === '') {
            toast.error("Please select the pickup date")
            return;
        }
        if (formData.pickup_time.length < 1 || formData.pickup_time === '') {
            toast.error("Please select the pickup time")
            return;
        }

        const currentMoment = moment();
        // Extract date strings for comparison in YYYY-MM-DD format
        const selectedDateStr = moment(formData.pickup_date).format('YYYY-MM-DD');
        const currentDateStr = currentMoment.format('YYYY-MM-DD');

        let selectedMoment;
        if (selectedDateStr === currentDateStr) {
            // If the selected date is today, combine the date and pickup time (e.g., "2025-03-26 5:30 PM")
            selectedMoment = moment(`${selectedDateStr} ${formData.pickup_time}`, 'YYYY-MM-DD h:mm A');
        } else {
            selectedMoment = moment(formData.pickup_date);
        }
        const timeDifference = selectedMoment.diff(currentMoment, 'hours', true);
        localStorage.removeItem('cab_listing');
        localStorage.setItem('cab_listing', JSON.stringify(formData));
        Navigation('/cab-listing')
    }



    return (
        <Form onSubmit={(e) => CabSearchSubmit(e)}>
            <div className="d-flex mb-3 justify-content-between">
                <CitySuggestionsCMP handleFormatted={HandleChangesData} tripType={tripType} formData={formData} />
                <SwapCityCMP />
                <OneWayCitySuggetion handleFormatted={HandleChangesData} tripType={tripType} formData={formData} />
                <DatePickerInput handleFormatted={HandleChangesData} setSelectedDate={setSelectedDate} tripType={tripType} setCheck={setCheck} />
                <TimePickerInput handleFormatted={HandleChangesData} selectedDateInput={selectedDate} tripType={tripType} />
            </div>
            <div className="softwbtn text-center">
                <Button variant="primary" type="submit">
                    Search Cab <img
                        src="/images/search.png"
                        alt="Search Icon"
                        title="Search"
                        loading="lazy"
                        width={20} height={20}
                        style={{ width: "revert-layer", height: "auto" }}
                    />
                </Button>
            </div>
        </Form>

    )
}


export default OneWaysSearchTab